import { useState } from 'react';
import { useLoginContext } from '../hooks/useLoginContext';
import SvgBg from '../bjerking_bg.svg';
import Logo from '../logo.png';

function LoginForm() {
    console.log('LoginForm')

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login, sendCredentials } = useLoginContext();

    const handleEmailChange = (e) => {
        setUsername(e.target.value)
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('email', username);
        formData.append('password', password);
        sendCredentials(formData)
    }

    return (
        <div className="Login">
            <div style={{ backgroundImage: `url(${SvgBg})` }}></div>
            <div>
                <div className="message">{login === 'error' && <div>Du angav fel användarnamn eller lösenord</div>}</div>
                <div className='LoginForm'>
                    <form onSubmit={handleFormSubmit}>
                        <header>
                            <img src={Logo} alt='' />
                            <h1>Ange inloggningsuppgifter</h1>
                        </header>
                        <div className="username">
                            <label>Användarnamn</label>
                            <input type="text" placeholder='' required value={username} onChange={handleEmailChange} className={login === 'error' ? "error" : ""} />
                        </div>

                        <div className="password">
                            <label>Lösenord</label>
                            <input type="password" placeholder='' required value={password} onChange={handlePasswordChange} className={login === 'error' ? "error" : ""} />
                        </div>

                        <div className="actions">
                            <div>
                                <div>
                                    <input id='remember' type='checkbox' />
                                    <label htmlFor="remember">Kom ihåg mig</label>
                                </div>
                                <div>Glömt lösenordet?</div>
                            </div>
                            <button type="submit">Logga in</button>
                        </div>

                    </form>
                </div>

                <footer>
                    &copy; {new Date().getFullYear()} Bjerking Digital - Automatisering och effektivisering
                </footer>
            </div>
        </div>
    )
}

export default LoginForm;